const translation = {
  custom: '定製',
  upgradeTip: {
    prefix: '升級您的計劃以',
    suffix: '定製您的品牌。',
    des: '升級您的計劃以自訂您的品牌',
    title: '升級您的計劃',
  },
  webapp: {
    title: '定製 web app 品牌',
    removeBrand: '移除 Powered by Dify',
    changeLogo: '更改 Powered by Brand 圖片',
    changeLogoTip: 'SVG 或 PNG 格式，最小尺寸為 40x40px',
  },
  app: {
    title: '定製應用品牌',
    changeLogoTip: 'SVG 或 PNG 格式，最小尺寸為 80x80px',
  },
  upload: '上傳',
  uploading: '上傳中',
  uploadedFail: '圖片上傳失敗，請重新上傳。',
  change: '更改',
  apply: '應用',
  restore: '恢復預設',
  customize: {
    contactUs: '聯絡我們',
    prefix: '如需在 Dify 內自定義品牌圖示，請',
    suffix: '升級至企業版。',
  },
}

export default translation
